import { Typography } from 'antd';
import styled, { css } from 'styled-components';

import Colors from '@rockalingua/ui/constants/Colors';
import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';

const { Text } = Typography;

export const variantStyles = {
  body: css`
    font-family: 'DM Sans';
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  `,
  'title-big-grey-42': css`
    font-family: 'greycliff-cf';
    font-size: 42px;
    font-weight: 600;
    line-height: 46px;

    @media (max-height: ${MediaQueryBreakpoints.height.xl}px) {
      font-size: 38px;
    }
  `,
  pageSubtitle: css`
    font-family: 'greycliff-cf';
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
  `,
  modalTitle: css`
    font-family: 'greycliff-cf';
    font-size: 21px;
    font-weight: 500;
    line-height: 28px;
  `,
  smallHeading: css`
    font-family: 'greycliff-cf';
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
  `,
  stepHeading: css`
    font-family: 'greycliff-cf';
    font-size: 16px;
    font-weight: 700;
    line-height: 21px;
  `,
  caption: css`
    font-family: 'DM Sans';
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
  `,
  'grey-12-semibold': css`
    font-family: 'greycliff-cf';
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  `,
  cardTitle: css`
    font-family: 'greycliff-cf';
    font-size: 18px;
    font-weight: 600;
    line-height: 21px;
  `,
  modalSubtitle: css`
    font-family: 'DM Sans';
    font-size: 14px;
    font-weight: 700;
    line-height: 21px;
  `,
  activityButton: css`
    font-family: 'greycliff-cf';
    font-size: 10px;
    font-weight: 500;
    line-height: 16px;
  `,
  gradeCardName: css`
    font-family: 'greycliff-cf';
    font-size: 17px;
    font-weight: 700;
    line-height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  `,
  'title-mid-grey-32': css`
    font-family: 'greycliff-cf';
    font-size: 32px;
    font-weight: 600;
    line-height: 36px;

    @media (max-height: ${MediaQueryBreakpoints.height.xl}px) {
      font-size: 28px;
      line-height: 32px;
    }

    @media (${MediaQueryBreakpoints.isUltraWide}) {
      font-size: 26px;
      line-height: 28px;
    }
  `,
  'title-small-grey-22': css`
    font-family: 'greycliff-cf';
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;

    @media (max-height: ${MediaQueryBreakpoints.height.xl}px) {
      font-size: 18px;
      line-height: 22px;
    }

    @media (${MediaQueryBreakpoints.isUltraWide}) {
      line-height: 20px;
    }
  `,
  'grey-56-bold': css`
    font-family: 'greycliff-cf';
    font-size: 56px;
    font-weight: 700;
    line-height: 100%;

    @media (max-height: ${MediaQueryBreakpoints.height.xl}px) {
      font-size: 42px;
    }
  `,
  'grey-22-bold': css`
    font-family: 'greycliff-cf';
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
  `,
  'grey-18-bold': css`
    font-family: 'greycliff-cf';
    font-size: 18px;
    font-weight: 700;
    line-height: 21px;
  `,
  'grey-18-semibold': css`
    font-family: 'greycliff-cf';
    font-size: 18px;
    font-weight: 600;
    line-height: 21px;
  `,
  'grey-16-bold': css`
    font-family: 'greycliff-cf';
    font-size: 16px;
    font-weight: 700;
    line-height: 21px;
  `,
  'grey-16-medium': css`
    font-family: 'greycliff-cf';
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
  `,
  'grey-14-medium': css`
    font-family: 'greycliff-cf';
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
  `,
  'grey-14-bold': css`
    font-family: 'greycliff-cf';
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
  `,
  'grey-14-demibold': css`
    font-family: 'greycliff-cf';
    font-size: 14px;
    font-weight: 600;
    line-height: 13px;
  `,
  'grey-13-medium': css`
    font-family: 'greycliff-cf';
    font-size: 13px;
    font-weight: 500;
    line-height: 15px;
  `,
  'grey-12-demibold': css`
    font-family: 'greycliff-cf';
    font-size: 12px;
    font-weight: 600;
    line-height: 13px;
  `,
  'grey-11-demibold': css`
    font-family: 'greycliff-cf';
    font-size: 11px;
    font-weight: 600;
    line-height: 14px;
  `,
  'dm-16-medium': css`
    font-family: 'DM Sans';
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
  `,
  'dm-16-regular': css`
    font-family: 'DM Sans';
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  `,
  'dm-14-regular': css`
    font-family: 'DM Sans';
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  `,
  'dm-14-medium': css`
    font-family: 'DM Sans';
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  `,
  'dm-14-bold': css`
    font-family: 'DM Sans';
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  `,
  'dm-12-medium': css`
    font-family: 'DM Sans';
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
  `,
  'dm-12-regular': css`
    font-family: 'DM Sans';
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
  `,
  'grey-12-medium': css`
    font-family: 'greycliff-cf';
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  `,
  'dm-11-medium': css`
    font-family: 'DM Sans';
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
  `,
} as const;

export type TextVariant = keyof typeof variantStyles;

export const colorStyles = {
  primary: css`
    color: ${Colors.MAIN_VARIANTS[60]};
  `,
  success: css`
    color: ${Colors.SUCCESS_VARIANTS[60]};
  `,
  error: css`
    color: ${Colors.ERROR_VARIANTS[50]};
  `,
  black: css`
    color: ${Colors.BLACK};
  `,
} as const;

export type TextColorPreset = keyof typeof colorStyles;

type StyledTextProps = {
  $variant?: TextVariant;
  $color?: TextColorPreset | string;
  $fontSize?: number;
  $fontWeight?: number;
};

export const StyledText = styled(Text)<StyledTextProps>`
  ${({ $variant }) => $variant && variantStyles[$variant]}

  ${({ $color }) => {
    if ($color && $color in colorStyles) {
      return colorStyles[$color as TextColorPreset];
    }

    return `color: ${$color};`;
  }}

  ${({ $fontSize }) =>
    $fontSize &&
    css`
      font-size: ${$fontSize}px !important;
    `}

  ${({ $fontWeight }) =>
    $fontWeight &&
    css`
      font-weight: ${$fontWeight};
    `}
`;
